<section>
  <app-skeleton [style]="'heading-h2-text'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'expandable-rows'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'heading-h2-text'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'big-block'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'heading-h2-text'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'big-block'" [count]="1"></app-skeleton>
  <app-skeleton [style]="'word-entity-selection'" [count]="1"></app-skeleton>
</section>
